import { createTheme } from '@mui/material/styles';
import palette from './palette';

export default createTheme({
  palette: {
    primary: {
      main: palette.slate,
    },
    secondary: {
      main: palette.sunburst,
    },
  },
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          " & label[data-shrink='false']": {
            top: '-10px',
            color: palette.typography.black.solid,
            transform: `translate(10px, 20px) scale(1)`,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          '&.Mui-focused': {
            color: palette.blue,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.blue,
          },
        },
        input: {
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          letterSpacing: '0.0025rem',
          padding: '0.3125rem 0.625rem',
          height: '1.25rem',
          '&::-webkit-input-placeholder': {
            color: palette.typography.black.solid,
            opacity: `1 !important`,
          },
        },
        notchedOutline: {
          fontSize: '0.875rem',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&[data-shrink="false"]': {
            color: 'gray',
            fontSize: '0.875rem',
            top: '-15px !important',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '0.625rem',
          textAlign: 'right',
        },
        contained: {
          marginRight: 0,
          marginTop: 0,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 3,
          '& svg': {
            fontSize: '1rem',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
          lineHeight: '1rem',
          marginRight: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: '2rem',
          fontSize: '0.875rem',
          lineHeight: '1rem',
          fontWeight: 'normal',
          textTransform: 'capitalize',
        },
        endIcon: {
          '& > *:nth-of-type(1)': {
            fontSize: 'inherit',
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorSecondary: {
          color: palette.typography.white.inactive,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          //marginTop: 0,
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        anchorOriginTopCenter: {
          top: '50% !important',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        daySelected: {
          border: 0,
        },
        current: {
          border: '0.063rem solid #DC0032',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popupIndicator: {
          transition: 'transform linear 200ms',
        },
        popupIndicatorOpen: {
          color: palette.blue,
          transform: 'rotate(180deg)',
        },
      },
    },
  },
});
